import { AxiosResponse } from 'axios';
import { call, put, takeLatest } from 'redux-saga/effects';
import { errorHandler } from '../utils.saga';
import { GET_CANDIDATES } from '../../constants/ActionTypes';
import { getAllCandidatesApi } from '../../api/Interviews/candidates.api';
import { showAlert } from '../../actions/alert.action';
import { IPayload } from '../../types/Interviews/jobRoles.types';
import { HTTP_STATUS_CODES } from '../../constants/HttpConstants';

/**
 * Get Candidates
 * @param {IPayload} data:IPayload
 * @returns {void}
 */
function* getCandidates(data: IPayload) {
  try {
    yield put({
      type: `SHOW_LOADER`,
      payload: {
        show: true,
      },
    });
    const getJobRolesResp: AxiosResponse = yield call(() =>
      getAllCandidatesApi(data.payload)
    );
    if (
      getJobRolesResp &&
      getJobRolesResp.status === HTTP_STATUS_CODES.OK &&
      getJobRolesResp.data
    ) {
      yield put({
        type: `${GET_CANDIDATES}_SUCCESS`,
        payload: getJobRolesResp.data,
      });
    } else {
      yield put(
        showAlert({
          message: getJobRolesResp.statusText,
          show: true,
          type: 'error',
        })
      );
    }
  } catch (err) {
    const message: string | null = yield call(errorHandler, err);
    if (message)
      yield put(
        showAlert({
          show: true,
          message,
          type: 'error',
        })
      );
  } finally {
    yield put({
      type: `HIDE_LOADER`,
    });
  }
}

/**
 * Load Candidates
 * @returns {void}
 */
export default function* loadCandidates() {
  yield takeLatest(GET_CANDIDATES, getCandidates);
}
